import a from"./_nativeCreate.js";var t=a;var _=function(a,_){var i=this.__data__;return this.size+=this.has(a)?0:1,i[a]=t&&void 0===_?"__lodash_hash_undefined__":_,this};export{_ as default};
//# sourceMappingURL=_hashSet.js.map
